import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", href: "/" },
  { label: "社会热点", href: "/category/social" },
  { label: "娱乐八卦", href: "/category/entertainment" },
  { label: "科技资讯", href: "/category/tech" },
  { label: "关于我们", href: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span
              className={`font-heading text-2xl md:text-3xl font-black tracking-tight transition-colors duration-300 ${
                scrolled ? "text-foreground-950" : "text-white"
              }`}
            >
              51<span className="text-accent-500">黑料</span>网
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item, idx) => (
              <div key={item.href} className="flex items-center">
                {idx > 0 && (
                  <span
                    className={`mx-1 text-xs transition-colors duration-300 ${
                      scrolled ? "text-foreground-300" : "text-white/40"
                    }`}
                  >
                    ◆
                  </span>
                )}
                <Link
                  to={item.href}
                  className={`px-3 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === item.href
                      ? scrolled
                        ? "text-primary-600 font-semibold"
                        : "text-white font-semibold"
                      : scrolled
                        ? "text-foreground-600 hover:text-primary-600"
                        : "text-white/80 hover:text-white"
                  }`}
                >
                  {item.label}
                </Link>
              </div>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3 shrink-0">
            <button
              className={`px-5 py-2 text-sm font-medium rounded-full border transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-600"
                  : "border-white/40 text-white hover:border-white hover:bg-white/10"
              }`}
            >
              订阅爆料
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? "text-foreground-950" : "text-white"
            }`}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
        } bg-background-50/98 backdrop-blur-md`}
      >
        <div className="px-4 py-4 flex flex-col gap-1">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                location.pathname === item.href
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <button className="mt-2 px-5 py-3 text-sm font-medium rounded-full border border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap">
            订阅爆料
          </button>
        </div>
      </div>
    </nav>
  );
}